export default __webpack_public_path__ + "static/media/real_estate_web-xs@2x.9bd31da4.jpg";